export default "__VITE_ASSET__n768FgBIF9Qkaoho5LLANg__"